import { useTranslations } from '@vocab/react';
import { Alert, Box, Column, Columns, Text } from 'braid-design-system';
import { useLocation } from 'react-router';

import { TextLink } from '../Link/Link';

import translations from './.vocab';

/* An AlertBox component prompting the user to log in,
// but providing a function to mock the login for local/staging
// testing purposes
*/
export const UserLoginPrompt = ({ returnUrl }: { returnUrl?: string }) => {
  const { t } = useTranslations(translations);
  const { search, pathname } = useLocation();
  const url = returnUrl ?? `/partners${pathname}${search}`;
  return (
    <Box id="user-login-prompt">
      <Columns space="gutter" collapseBelow="tablet" alignY="center">
        <Column>
          <Alert tone="info">
            <Text>
              {t('Please sign in to continue', {
                TextLink: (children) => (
                  <TextLink
                    href={`/oauth/login/?returnPath=${encodeURIComponent(url)}`}
                    tracking="signin-button-clicked"
                  >
                    {children}
                  </TextLink>
                ),
              })}
            </Text>
          </Alert>
        </Column>
      </Columns>
    </Box>
  );
};
